// Channel from current URL (embarca-ai vs white-label).
import { resolveOperatorFromHostSync } from "@/lib/operatorDomains";

export function getPlatform(preFixChannel?: string) {
  // Obtém a URL atual do navegador
  const url = typeof window !== "undefined" ? window.location.href : "";

  if (!url) {
    if (preFixChannel) {
      return `${preFixChannel}-white-label`;
    }
    return "embarca-ai";
  }

  let urlObj: URL;
  try {
    urlObj = new URL(url);
  } catch (error) {
    return "embarca-ai";
  }

  const host = urlObj.host.toLowerCase();
  const domain = host.replace(/^www\./i, "");

  // 1. Definição estrita dos domínios da Embarca.ai
  const EMBARCA_AI_DOMAINS = [
    "embarca.ai",
    "www.embarca.ai",
    "passagens.embarca.ai",
    "embarca-staging.com.br",
    "www.embarca-staging.com.br",
    "localhost",
    "localhost:3000",
  ];

  if (EMBARCA_AI_DOMAINS.includes(domain)) {
    return "embarca-ai";
  }

  // 2. Heroku review/staging apps são sempre Embarca.ai
  if (domain.endsWith(".herokuapp.com")) {
    return "embarca-ai";
  }

  // 3. White label (strapi-gbs custom domains + legacy patterns)
  const isCustomDomainWhiteLabel = resolveOperatorFromHostSync(host) !== null;
  const isWhiteLabel =
    isCustomDomainWhiteLabel ||
    domain.includes("viacaogarcia.com.br") ||
    domain.endsWith(".embarca.ai") ||
    domain.endsWith(".embarca-staging.com.br") ||
    (domain.includes(".localhost") && !domain.startsWith("embarca."));

  if (isWhiteLabel) {
    if (preFixChannel) {
      return `${preFixChannel}-white-label`;
    }
    return "white-label";
  }

  // 4. Fallback para qualquer outro domínio (Tratamos como WL se não for domínio oficial Embarca)
  if (preFixChannel) {
    return `${preFixChannel}-white-label`;
  }
  return "white-label";
}
